export default () => ({
  selectedTestResults: {
    laboratory: [],
    images: []
  },
  selectedResultsToAnalyze: {
    laboratory: [],
    images: []
  },
  resultsBeingAnalyzed: {
    laboratory: {},
    images: {}
  },
  testResultFeedbackMessage: null
})
